import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertPlanningMessageModelComponent } from './alert-planning-message-model.component';
import { MaterialModule } from '@fuse/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,

    TranslateModule
  ],
    exports: [AlertPlanningMessageModelComponent],
    declarations: [AlertPlanningMessageModelComponent]
})
export class AlertPlanningMessageModelModule { }
